module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAARklEQVR4AWMYVuA/EI5wDYwMTQwNpGjQY/gL5DeQ4qRIiBZS/BAF0UKKp6PxafmPBzaQqYEwiGH4O9DKMSOOBNAAhEMDAACnREkyhnS/DgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/ic_subdirectory_arrow_right_black_24dp_1x.png
// module id = 965
// module chunks = 0